// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1yEEv","savePackageButton":"ClientWallet_savePackageButton__3-bQM"};